import React from 'react'
import SEO from '../components/SEO'
import { Link } from 'react-router-dom'

export default function Team() {
  return (
    <div className="container my-5">
      <SEO title="Our Team | 100Eyes Technologies LLP" description="Meet the 100Eyes Technologies team — engineers, designers and product experts delivering secure, scalable software solutions for businesses." canonical="https://100eyestechnologies.com/team" />

      <h1>Our Team</h1>
      <p>
        The 100Eyes Technologies team is a cross-functional group of engineers, designers, data specialists and delivery managers.
        We combine deep technical skills with a product mindset to build reliable systems that solve real customer problems.
      </p>

      <p>
        Our engineers focus on secure, maintainable architectures and apply best practices for testing, observability and performance.
        Want to work with us? <Link to="/contact-us">Contact our team</Link> to discuss hiring, partnerships or client engagements.
      </p>

      <h3>Core Capabilities</h3>
      <ul>
        <li>Full-stack web & mobile engineering</li>
        <li>Cloud architecture & migrations</li>
        <li>Data engineering & analytics</li>
        <li>AI automation & integrations</li>
      </ul>
    </div>
  )
}
